export const SET_OIDC_OBJ = 'SET_OIDC_OBJ';

export const setOidcObj = (oidcObj) => ({
    type: SET_OIDC_OBJ,
    payload: oidcObj
});